import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';
import { emptyStringValues } from '@/utils/objects';

import { TPatchSegmentTranscription, TSegmentTranscriptions } from '../types';

import { segmentsQueryKeys } from './query-keys';

type TPatchSegmentTranscriptionBody = {
  id: string;
  body: TPatchSegmentTranscription;
};
export async function patchSegmentTranscription({
  id,
  body,
}: TPatchSegmentTranscriptionBody): Promise<TSegmentTranscriptions> {
  return mediaManagerClient.patch(`/api/v1/segment_transcriptions/${id}`, emptyStringValues(body));
}

type MutationFn = typeof patchSegmentTranscription;

type TUsePatchSegmentTranscriptionParams = {
  config?: MutationConfig<MutationFn>;
};

export function usePatchSegmentTranscription({ config }: TUsePatchSegmentTranscriptionParams = {}) {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const { addErrorNotification, addSuccessNotification } = useNotificationStore();

  return useMutation({
    ...config,
    mutationFn: patchSegmentTranscription,
    onError(error) {
      addErrorNotification(t('No se ha podido actualizar la transcripción del segmento'));
      console.error(error);
    },
    onSuccess() {
      queryClient.invalidateQueries({
        queryKey: segmentsQueryKeys.all,
      });
      addSuccessNotification(t('La transcripción del segmento se ha actualizado correctamente'));
    },
  });
}
